import 'react-image-crop/dist/ReactCrop.css'

import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { Crop } from 'react-image-crop'
import ReactCrop from 'react-image-crop'

import { useBoundStore } from '../../store/store'
import type { ApiResponse } from '../../types/api'
import { api } from '../../utils/api-client'
import closeModal from '../../utils/closeModal'
import { TailSpin } from '../loaders'
import Modal from './modal'

interface UploadProfileProps {
  imageSrc: string | ArrayBuffer | null
}

const UploadProfileModal = ({ imageSrc }: UploadProfileProps) => {
  const setProfilePicture = useBoundStore(state => state.user.setProfilePicture)
  const modal = useModal()
  const { t } = useTranslation('personalData')
  const imageRef = useRef<HTMLImageElement>(null)
  const [crop, setCrop] = useState<Crop>({
    width: 100,
    height: 100,
    unit: 'px',
    x: 0,
    y: 0,
  })
  const [isLoading, setIsLoading] = useState(false)

  const onUpload = async () => {
    if (!imageRef.current) return
    const imageElement = imageRef.current
    try {
      const canvas = document.createElement('canvas')
      const scaleX = imageElement.naturalWidth / imageElement.width
      const scaleY = imageElement.naturalHeight / imageElement.height
      canvas.width = crop.width
      canvas.height = crop.height
      const ctx = canvas.getContext('2d')
      if (!ctx) return
      ctx.drawImage(
        imageElement,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height,
      )

      const blob = await new Promise(resolve => {
        canvas.toBlob(blob => {
          resolve(blob)
        }, 'image/png')
      })

      if (!blob) return

      setIsLoading(true)
      const response = await api.uploadMedia<ApiResponse<string>>(
        '/ajax_data.php',
        {
          file: blob,
          type: 'upload_pictures',
        },
      )
      const { status } = response.data
      if (status === 1) {
        const response = await api.post<ApiResponse<string>>('/ajax_data.php', {
          type: 'get_imgurl',
        })
        const { status, info } = response.data
        if (status === 1) {
          setProfilePicture(info)
        }

        await closeModal(modal)
      }
      setIsLoading(false)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Modal
      id="upload-profile-modal"
      containerStyle="bg-transparent w-max max-w-[calc(100vw_-_40px)] !border-0">
      <div className="flx-ctr" style={{ marginBottom: '20px' }}>
        <ReactCrop
          crop={crop}
          onChange={c => setCrop(c)}
          aspect={1}
          circularCrop>
          <img
            className="max-w-[calc(100vw_-_40px)] max-h-[calc(100vh_-_200px)]"
            ref={imageRef}
            src={imageSrc as string}
            alt="Crop"
          />
        </ReactCrop>
      </div>
      <div className="flx-ctr gap-2 w-[300px] mx-auto my-0 xl:w-[400px]">
        <button
          className="text-[13px] font-Syncopate-Bold uppercase text-white flex-1 bg-[#65676a] rounded px-0 py-[13px] secondary"
          onClick={() => closeModal(modal)}>
          {t('cancel')}
        </button>
        {isLoading ? (
          <div className="flx-ctr h-[38px] flex-1">
            <TailSpin color="#DF0033" width={30} height={30} />
          </div>
        ) : (
          <button
            className="text-[13px] font-Syncopate-Bold uppercase text-white flex-1 bg-[#df0033] rounded px-0 py-[13px]"
            onClick={onUpload}>
            {t('confirm')}
          </button>
        )}
      </div>
    </Modal>
  )
}

export default NiceModal.create(UploadProfileModal)
